import useClasses from 'hooks/API/GET/useClasses';
import useManageClass from 'hooks/API/useManageClass';
import useToaster from 'hooks/useToaster';
import { useParams, useHistory } from 'react-router-dom';
import ClassHandleSection from './ClassHandleSection';
import * as AppPics from 'assets/images';
import AppBreadcrumbs from 'components/molecules/AppBreadcrumbs';

function ManageClass() {
  const { isLoading, mutate, isError } = useManageClass();
  const { classID } = useParams();
  const history = useHistory();

  const handleGoBack = () => {
    history.goBack();
  };

  useToaster(isLoading, { type: isError ? 'error' : 'success' });

  const { data } = useClasses({
    enabled: !!classID,
    classID,
  });

  function handleClass(classFormData = {}) {
    if (isLoading) return;

    if (data?.data?._id) {
      classFormData.id = data?.data?._id;
    }

    mutate(classFormData);
  }

  return (
    <div className="mainWraper coursetabsection">
      <div className="tab">
        <ul className="tab__menu">
          <li className="back">
            <button className="btn-back" onClick={handleGoBack}>
              <img src={AppPics.BackSvg} alt="Back" />
            </button>
          </li>
        </ul>

        <div className="tab__content ___adjust___tab___padding">
          <div className="tab__content-actHead">
            <AppBreadcrumbs
              links={[
                { label: 'Dashboard', to: '/dashboard' },
                { label: 'Curriculum', to: '/curriculum' },
                { label: 'Classes', to: '/manage/classes' },
              ]}
              current={classID ? 'Update Class' : 'Add Class'}
            />
          </div>

          <div className="tab__content-actBody">
            <div className="px-5 py-2">
              <ClassHandleSection
                handleClass={handleClass}
                preloadedData={data?.data ?? {}}
                editMode={!!classID}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ManageClass;
